import { SectionTitle, CmpTable } from "../shared";
import SubComponent from "./SubComponent";
import { ALL_EMBED_JS } from "./query";

const EmbedJSList = () => {
    const columns = [
        {
            accessorKey: "embedJsKey",
            header: "Embed JS Key",
        },
        {
            accessorKey: "demandNo",
            header: "Demand No",
        },
        {
            accessorKey: "publishStatus",
            header: "Status",
            cell: (cell) => (cell.getValue() ? "Published" : "Unpublished"),
        },
    ];

    const renderSubComponent = (data) => <SubComponent data={data.row.original} />;

    return (
        <>
            <SectionTitle
                title="Embed JS"
                buttonUrl="/global-config/embed-js/create"
                backUrl="/global-config"
            />

            <CmpTable
                QUERY={ALL_EMBED_JS}
                getRowCanExpand={() => true}
                headers={columns}
                renderSubComponent={renderSubComponent}
                dataPath="allAbbvieProEmbedJsSnippets"
                variables={{ country: [], appName: [] }}
            />
        </>
    );
};

export default EmbedJSList;
